import React from "react";
import "./styled.css";
import { FaWhatsapp } from "react-icons/fa";
import ReactGa from "react-ga";

const WHATSAPP_URL = "https://wa.link/wq8fpf";

const BotonFlotante = () => {
  const medicionClick = () => {
    ReactGa.event({
      category: "WhatsApp",
      action: "Click",
    });
  };

  const handleClick = () => {
    medicionClick();
    window.open(WHATSAPP_URL, "_blank");
  };

  return (
    <div className="boton-flotante" onClick={handleClick}>
      <div className="icono-messenger">
        <FaWhatsapp size={24} />
      </div>
    </div>
  );
};

export default BotonFlotante;
